import { RangeSet } from "@omni/types/api/product/bff/shared/rangeSet.model";
import { CloudRangeSet } from "@omni/types/api/product/cloud/shared/rangeSet.model";
import { NullableModelMapper } from "@omni/types/utils/modelMapper";

import { RangeMapper } from "./range.mapper";

const fromCloud: NullableModelMapper<CloudRangeSet, RangeSet> = (model) => {
    if (!model) {
        return null;
    }

    return {
        name: model.name,
        ranges: model.ranges.map(RangeMapper.fromCloud),
        type: model.type
    } satisfies RangeSet;
};

export const RangeSetMapper = {
    fromCloud
};
